//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Picker,
  Popup,
} from 'vant'
import {
  dig,
  last,
} from '@/utils/lodash'
import CInput from '../CInput'
import { isEmptyAll } from '../../utils/validator'
import { filterByLabelFormat } from '../../utils/translate'
import CJumpPage from '../CJumpPage'
import TSelectPage from './TSelectPage'

export default {
  name: 'CSelect',

  components: {
    Popup,
    Picker,
    CInput,
    CJumpPage,
  },

  inheritAttrs: false,

  props: {
    value: {
      type: [
        String,
        Number,
        Array,
        Object,
      ],
    },

    otherPageComponent: {
      type: Object,
      default: () => {
        return TSelectPage
      },
    },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    leftClick: { type: Function },

    showAction: {// 是否显示筛选按钮
      type: Boolean,
      default: false,
    },

    searchable: {// 是否可查询
      type: Boolean,
      default: false,
    },

    currentPage: {// 是否在当前页选择
      type: Boolean,
      default: true,
    },

    multi: {// 是否支持多选
      type: Boolean,
      default: false,
    },

    maxLevel: {
      type: Number,
      default: 0,
    },

    apiMethod: { type: Function },

    bottomRender: { type: Function },

    dataHook: { type: Function },

    dataPath: {
      type: String,
      default: 'data',
    },

    params: {
      type: Object,
      default: () => ({}),
    },

    mode: {
      type: String,
      default: '',
    },

    classSetting: {
      type: String,
      default: '',
    },

    valueName: {
      type: String,
      default: 'key',
    },

    queryName: {
      type: String,
      default: 'wid',
    },

    labelFormat: {
      type: String,
      default: '{value}',
    },

    list: {
      type: Array,
      default: () => ([]),
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    tree: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    searchRender: {
      type: Array,
      default: () => ([]),
    },

    beforeConfirm: { type: Function },

    searchCardFormat: {
      type: [
        Array,
        Function,
      ],
      default: () => {
        return [
          {
            label: '中学名称',
            value: 'name',
          },
          {
            label: '地区',
            value: 'wid',
          },
        ]
      },
    },

    overlayClass: {
      type: String,
      default: '',
    },

  },

  data () {
    return {
      TSelectPage,
      componentsParams: {},
      popupVisible: false,
      innerParams: {},
      options: [],
      currentNameIsEmpty: true,
      checkedValue: [],
      originalChecked: [],
    }
  },

  computed: {
    rightIcon () {
      return (this.readonly || this.disabled || !this.clearable) ? '' : (this.currentNameIsEmpty ? 'arrow' : 'cross')
    },

    showName: {
      get () {
        if (this.tree) {
          const name = this.getPath(this.options, this.value)?.name || []

          return name?.join('') || ''
        } else if (this.multi && (this.value instanceof Array)) {
          return this.options.filter((el) => this.value.indexOf(el[this.valueName]) >= 0).map((el) => el.text)
            .join(',')
        } else {
          return this.options.filter((el) => el[this.valueName] === this.value)[0]?.text
        }
      },
      set (val) {

      },
    },

    defaultIndex () {
      if (this.tree) {
        return 0
      } else {
        return this.options.findIndex((el) => el[this.valueName] === this.value)
      }
    },
  },

  watch: {
    showName (val) {
      this.currentNameIsEmpty = isEmptyAll(val)
    },

    list: {
      deep: true,
      immediate: true,
      handler (v) {
        this.options = this.filterData(v || [])
      },
    },

    value: {
      async handler (val, old) {
        if (!isEmptyAll(val)) {
          this.innerParams = { [this.queryName]: val }

          if (isEmptyAll(old) && !this.options?.length) {
            await this.doQuery()
          }
        }

        this.$emit('on-change', val, this.options)
      },
      deep: true,
      immediate: true,
    },
  },

  async created () {
    delete this.$listeners?.input
  },

  methods: {
    isEmptyAll,

    onChangeOptions (options) {
      this.options = options
    },

    changeValue (value) {
      this.$emit('input', value)
    },

    reload () {
      this.$refs.cSearch._load()
    },

    async doQuery () {
      if (this.apiMethod) {
        const result = await this.apiMethod({
          ...this.innerParams,
          ...this.params,
        }, this.methodConfig, this.postMethod)

        let data = dig(result, this.dataPath) || []

        if (this.dataHook) {
          data = this.dataHook(data || [])
        }

        this.options = this.filterData(data || [])
      }
    },

    filterData (data) {
      if (this.tree) {
        this.filterTreeData(data)

        return data

        // return this.treeAllList.map((el, index) => {
        //   return { values: el.values }
        // })
      } else {
        return data.map((el) => {
          return {
            ...el,
            text: filterByLabelFormat(el, this.labelFormat),
          }
        })
      }
    },

    rightIconClick () {
      if (this.currentNameIsEmpty && this.rightIcon === 'arrow') {
        this.handlerSelectClick()
      } else {
        this.doClear()
      }
    },

    doClear () {
      if (this.multi) {
        this.$emit('input', this.value === undefined ? undefined : [])
      } else {
        this.$emit('input', this.value === undefined ? undefined : '')
      }
    },

    handlerSelectClick () {
      if (this.currentPage) {
        this.showPopup()
      } else {
        const vm = this.$refs[`c-jump-page-${this._uid}`]

        if (vm) {
          vm.click()
        }
      }
    },

    async handlerClickBeforeToOtherPage () {
      if (this.$attrs?.beforeClick) {
        return this.$attrs.beforeClick
      }

      this.componentsParams = {
        ...this.$props,
        ...this.$attrs,
        scopedSlots: this.$scopedSlots,
        slots: this.$slots,
      }

      await this.$nextTick()

      return true
    },

    async showPopup () {
      if (isEmptyAll(this.value) && !this.options?.length) {
        await this.doQuery()
      }

      this.showCurrentPagePopup()
    },

    onCancel () {
      this.popupVisible = false
    },

    onConfirm (val = '', index) {
      const selectValues = this.$refs.picker.getValues()
      const tempVal = this.tree ? last(selectValues.filter((el) => el[this.valueName])
        .map((el) => el[this.valueName])) : val[this.valueName]

      if (this.beforeConfirm && !this.beforeConfirm(tempVal, val)) {
        return
      }

      this.$emit('input', tempVal)
      this.popupVisible = false
    },

    async showCurrentPagePopup () {
      if (this.readonly) {
        return
      }

      this.popupVisible = true

      await this.$nextTick()
      if (this.tree) {
        const picker = this.$refs.picker
        const pickerList = picker.getValues()
        const valuePath = this.getPath(this.options, this.value)?.value || []

        const currentValue = valuePath && valuePath?.length ? valuePath : pickerList.map((el) => el && el[this.valueName])

        valuePath.forEach((el, index) => {
          picker.setColumnValues(index, this.findNodeByParentKey(currentValue[index]))

          picker.getColumnValues(index).forEach((item, itemIndex) => {
            if (currentValue.indexOf(item[this.valueName]) >= 0) {
              picker.setColumnIndex(index, itemIndex)
            }
          })
        })
      }
    },

    findNodeByParentKey (key) { // 根据父wid找到当前节点数据
      let nodeData = []
      const _self = this

      if (!key) {
        return nodeData
      }

      find(this.options)
      function find (data = []) {
        data.forEach((el, index) => {
          if (key === el[_self.valueName]) {
            nodeData = data || []
          }

          if (el.children?.length) {
            find(el.children || [])
          }
        })
      }

      return nodeData
    },

    filterTreeData (data) {
      const maxLevel = this.maxLevel || 3

      data.forEach((el, index) => {
        el.text = el.name || filterByLabelFormat(el, this.labelFormat)

        // maxLevel = Math.max(el.level, maxLevel)

        // data[index].parentCode = parentCode

        // if (el?.children?.length) {
        if (el.level < maxLevel) {
          el.children = el.children?.length ? el.children : [
            {
              text: '',
              level: el.level + 1,
            },
          ]

          this.filterTreeData(el.children)
        }
      })
    },

    onChange (picker, values, index) {
      if (this.tree) {
        for (let i = values.length - 1; i > index; i--) {
          picker.setColumnValues(i, [])
        }

        for (let i = index + 1; i < values.length; i++) {
          picker.setColumnValues(i, picker.getValues()[i - 1]?.children || [])
        }
      }
    },

    getPath (data = [], value) {
      let valuePath = ''
      let namePath = ''
      const valueName = this.valueName
      const currentValue = this.value

      getTreePath(data, value)

      function getTreePath (data = [], value, path = '', showName = '') {
        data.forEach((el, index) => {
          if ((`${el[valueName]}`) === (`${value}`)) {
            path += `_${el[valueName]}`
            showName += `_${el.text}`
            valuePath = path.split('_').filter(Boolean)
              .map((el) => typeof currentValue === 'number' ? +el : el)
            namePath = showName.split('_').filter(Boolean)
          } else if (el.children) {
            getTreePath(el.children, value, `${path}_${el[valueName]}`, `${showName}_${el.text}`)
          }
        })
      }

      return {
        value: valuePath,
        name: namePath,
      }
    },

  },
}
